export async function getWorks({commit}, payload = {}) {
  const {errResponse, data: dataResponse} = await this.$frontendRepositories.work.getWorksList(payload);

  if(!errResponse) {
    commit('setList', dataResponse.data)
  }

  return Promise.resolve(dataResponse.data);
}
export async function getWorksByEncryptId(_, id) {
  return await this.$frontendRepositories.work.getWorkFromEncryptId(id);
}